import React, { useState } from "react";
import Page from "../molecules/Page";

const apiUrl = process.env.REACT_APP_API_SOURCE;

const PasswordReset = () => {
  // --- LOGIKA KOMPONENTU POZOSTAJE BEZ ZMIAN ---
  const [email, setEmail] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [message, setMessage] = useState("");
  const [error, setError] = useState("");

  const handleEmailChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setMessage("");
    setError("");

    try {
      const response = await fetch(`${apiUrl}password_reset/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ email }),
      });

      if (response.ok) {
        setMessage("E-mail z linkiem do zresetowania hasła został wysłany.");
      } else if (response.status === 400) {
        // Brak konta z tym mailem albo konto z Google/Apple (bez hasła) — biblioteka zwraca wtedy 400.
        setError(
          "Nie mamy konta z hasłem na ten adres. Jeśli zakładałeś konto przez Google lub Apple, wróć i zaloguj się tym przyciskiem."
        );
      } else {
        const errorData = await response.json();
        setError(
          errorData?.message ||
            "Wystąpił błąd. Upewnij się, że użytkownik o podanym adresie istnieje i spróbuj ponownie."
        );
      }
    } catch (err) {
      setError("Błąd połączenia. Sprawdź swoje połączenie i spróbuj ponownie.");
    } finally {
      setIsSubmitting(false);
    }
  };
  
  // --- START ZMIAN WIZUALNYCH ---
  return (
    <Page showNav={false}>
      {/* ZMIANA: Główny kontener i wrapper, tak jak w pozostałych komponentach */}
      <div className="flex flex-col max-w-2xl mx-auto w-full flex-grow px-4 lg:px-0">
        <div className="bg-white rounded-xl lg:rounded-[3rem] shadow-[4px_4px_12px_rgba(0,0,0,0.30)] border border-gray-200 py-8 px-6 lg:px-14 w-full space-y-6 mt-[3vh] lg:mt-[8vh]">
          
          {/* ZMIANA: Styl nagłówka */}
          <h2 className="text-center text-xl font-apotek uppercase tracking-widest font-semibold text-[#233855]">
            Resetowanie hasła
          </h2>

          <form className="space-y-6" onSubmit={handleSubmit}>
            <div>
              {/* ZMIANA: Styl etykiety */}
              <label htmlFor="email" className="block text-[0.8rem] font-apotek uppercase tracking-widest font-semibold text-[#233855] mb-2">
                Podaj swój adres e-mail
              </label>
              {/* ZMIANA: Styl pola input */}
              <input
                type="email"
                id="email"
                required
                value={email}
                onChange={handleEmailChange}
                className="block w-full rounded-lg border border-gray-300 bg-white px-3 py-2 text-base text-gray-900 shadow-sm placeholder:text-gray-400 focus:border-[#233855] focus:ring-1 focus:ring-[#233855] sm:text-sm/6"
              />
            </div>

            <div>
              {/* ZMIANA: Styl przycisku + style dla stanu disabled */}
              <button
                type="submit"
                disabled={isSubmitting}
                className="flex w-full justify-center rounded-lg bg-[#233855] px-3 py-2 text-sm font-apotek uppercase tracking-widest text-slate-100 shadow-lg hover:bg-[#345081] focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-[#233855] disabled:bg-slate-400 disabled:cursor-wait"
              >
                {isSubmitting ? "Wysyłanie..." : "Zresetuj hasło"}
              </button>
            </div>

            {/* ZMIANA: Styl linku */}
            <div className="flex w-full justify-center">
              <div className="text-sm">
                <a href="/login" className="font-semibold text-[#8A0000] hover:text-[#345081]">
                  Wróć do logowania
                </a>
              </div>
            </div>
          </form>

          {/* ZMIANA: Przeniesienie komunikatów do wewnątrz kontenera dla spójności */}
          <div className="text-center">
            {message && <p className="text-sm text-green-600 mt-4">{message}</p>}
            {error && <p className="text-sm text-red-600 mt-4">{error}</p>}
          </div>

        </div>
      </div>
    </Page>
  );
};

export default PasswordReset;